import { ECountryCode, EDomicileTypes } from "../index.dto";

export const getAddressTitle = (
  countryCode: ECountryCode,
  domicileType: EDomicileTypes
) => {
  if (countryCode === ECountryCode.ID) {
    return domicileType === EDomicileTypes.LOCAL
      ? "Address on KTP"
      : "Address on National ID";
  }

  return "Office Address";
};

export const INDUSTRY_TYPE_LIST = [
  "Agriculture, forestry, and fishing",
  "Mining and quarrying",
  "Manufacturing",
  "Construction",
  "Wholesale and retail trade",
  "Transportation, Accommodation, and Food Service",
  "Virtual asset service providers",
  "Financial Service",
  "Money Service Business",
  "Information and Communication",
  "Real Estate or Dealers in high value good",
  "Travel Agency and Tour Operations",
  "Education",
  "Art, entertainment and recreation",
  "Professional, scientific and technical activities",
  "Religious and non profit organization",
  "Other",
];
